import React from "react";
import styled from "styled-components";
import Layout from "../components/Layout";
import SEO from "../components/SEO";
import mediaQuery from '../styles/mq'
import { Content as ContentStyle } from './bug-bounty'

const Content = styled(ContentStyle)`
  height: 100vh;

  ${mediaQuery('sm')(`
    height: auto;
  `)}
`;

const disclaimer = () => {
  return (
    <Layout>
      <SEO title="Energiswap: Disclaimer" description="Legal disclaimers to read before using the Energiswap website or app." />
      <Content>
        <h1>Energiswap Disclaimer</h1>
        <div>
          <p>
            All tokens, coins, and assets (synthetic or otherwise), hereby
            referred to as “Assets”, traded on Energiswap must exist on the Energi
            blockchain. Assets that are not $NRG are synthetic or tokenized
            versions of the underlying asset. When purchasing or trading Assets on
            Energiswap, you are not purchasing the underlying asset. While every
            attempt has been made to ensure that the price of Assets on Energiswap
            are reflective of the current price of the underlying assets, Energi
            accepts no liability for deviations between the price of Assets on
            Energiswap and their underlying assets on other exchanges or
            marketplaces.
          </p>
          <p>
            Energi and their employees and agents accept no liability for any loss
            or other damages incurred by users of the platform. Users are solely
            responsible for securing their assets. All information published on
            this website is not intended as financial advice and should not be
            taken as such. Any technical information on the website, while
            considered accurate at the time of publishing, is subject to change
            without notice.
          </p>
        </div>
      </Content>
    </Layout>
  );
};

export default disclaimer;
